import initImagePromoGrid from "../initImagePromoGrid.js";

document.addEventListener("DOMContentLoaded", () => {
  initImagePromoGrid();
});
